import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
// Services
import { CookieService } from 'ngx-cookie';
import { HelperService } from './helper.service';
import * as io from 'socket.io-client';

import { environment } from 'environments/environment';

/**
 * Generic Socket Service
 */
@Injectable()
export class SocketService {
  private socket;
  private token;
  /**
   * @param  {CookieService} CookieService Cookie Service
   */
  constructor(private cookieService: CookieService, private helperService: HelperService) {
    this.socketConnect();
  }

  /**
   * @param  {string} event Event name
   * @returns {Observable} Data Observable
   */
  public socketOn(event): Observable<any> {
    return new Observable((observer) =>
      this.socket.on(event, (data: any, ack?) => {
        observer.next(this.helperService.decryptData(data));
        const user = this.helperService.jwtDecode(this.token);
      })
    );
  }

  public removeListener = (event, fn?) => this.socket.removeListener(event);

  public socketDisconnect = () => this.socket.disconnect();

  socketConnect(token?: string) {
    this.token = token || this.cookieService.getObject('alpat');
    const config: Partial<io.ManagerOptions & io.SocketOptions> = {
      auth: {
        token: this.token
      },
      transports: ['websocket'],
      forceNew: false,
      secure: true,
    };
    this.socket = io.connect(`${environment.alpServicesUrl}/`, config);
    this.socket.on('error', (error) => {
      this.socketDisconnect();
    });
  }

  /**
   * ==============================
   *             Socket
   * ==============================
   */

  /**
   * @param  {string} event Event name
   * @param  {object} data Data Object
   * @returns {void}
   */
  public socketEmit = (event, data, ack?) => {
    this.socket.emit(event, this.helperService.encryptData(data), ack);
  };
}